import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import { TranslatePipe } from '@recruitee/i18n';

import { BadgeComponent } from '../../common/badge/badge.component';
import { IconComponent } from '../../common/icon/icon.component';
import { RtTooltip } from '../../common/tooltip/tooltip.directive';
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
  selector: 'rt-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.less'],
  standalone: true,
  imports: [
    CheckboxComponent,
    ReactiveFormsModule,
    BadgeComponent,
    TranslatePipe,
    NgTemplateOutlet,
    RtTooltip,
    IconComponent,
  ],
})
export class SelectableCardComponent {
  @Input() public control: UntypedFormControl;
  @Input() public disabled: boolean = false;
  @Input() public label: string;
  @Input() public description: string;
  @Input() public isNew?: boolean = false;
  @Input() public tooltip: string;
  @Input() public helpTooltip?: string;

  @Output() public valueChanges: EventEmitter<string | boolean | null> = new EventEmitter();
}
